import React from 'react';

export interface TextInputPropsBase {
  error?: string[];
}

type TextInputProps = TextInputPropsBase & React.InputHTMLAttributes<HTMLInputElement>;

export function TextInput(props: TextInputProps) {
  const { error, className: propClasses, ...rest } = props;

  const errored = (error?.length ?? 0) > 0;

  const classes = ['w-full rounded-lg border px-3 py-2 text-sm'];
  if (errored) classes.push('text-error border-error');
  else classes.push('border-border');
  if (propClasses) classes.push(propClasses);
  classes.push('go-text-input');

  return (
    <div className="w-full">
      <input {...rest} className={classes.join(' ')} />
      {errored && <div className="text-error text-sm">{props.error}</div>}
    </div>
  );
}
